module.exports = __webpack_public_path__ + "static/img/money54.6b4dfbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/money54.png
// module id = FFuu
// module chunks = 73